import { useTranslation } from 'react-i18next';
import type { StockTransferStatus } from '@optiflow/types';
import { Badge } from '@/components/ui/Badge';

/** Amber for the two states that need a human to do something: more is coming, or something is missing. */
const TONES: Record<StockTransferStatus, 'neutral' | 'brand' | 'success' | 'warning' | 'danger'> = {
  DRAFT: 'neutral',
  DISPATCHED: 'brand',
  PARTIALLY_RECEIVED: 'warning',
  RECEIVED: 'success',
  RECEIVED_WITH_VARIANCE: 'warning',
  CANCELLED: 'danger',
};

export function TransferStatusBadge({ status }: { status: StockTransferStatus }) {
  const { t } = useTranslation();

  return <Badge tone={TONES[status]}>{t(`inventory.transfers.status.${status}`)}</Badge>;
}
